import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import FileUploader from "../../../TCPForms/reusableComponents/FileUploader";
import ButtonWrapper from "../../components/Button";
import { InfoBox, SummaryCard } from "../../components/StyledComponent";
import { FaFilePdf } from "react-icons/fa";
import { getDocumentByFileStoreId } from "@egovernments/digit-ui-libraries/src/utils/fileType";
import { bindActionCreators } from "redux";
import { formMTDocActions } from "@egovernments/digit-ui-module-core/src/redux/actions";
import { Col, Row } from "react-bootstrap";

const Step2 = ({ formData, handleTabChange, tenantId }) => {
  console.log(formData, "formDataStep2");

  const dispatch = useDispatch();
  const { initFormMTDocs } = bindActionCreators(formMTDocActions, dispatch);
  const { documents } = useSelector((state) => state.formMT);
  const userInfo = Digit.UserService.getUser();
  const { t } = useTranslation();
  const isDA = formData?.department === "DA";
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const defaultValues = {
    ...formData,
  };
  const isScheme = formData?.descriptionOfLand?.schemeType === "Scheme";
  const { handleSubmit, control, setValue } = useForm({ defaultValues });
  async function fetchLTPData() {
    const createdBy = userInfo?.info?.uuid;
    try {
      const response = await Digit.OBPSService.BPAREGSearch(tenantId, {}, { createdBy: createdBy });
      const ltpData = response?.Licenses?.filter((e) => e.status === "APPROVED") || [];
      console.log(response, ltpData, "ltpDataaaaaa");
      const regCert = ltpData?.[0]?.tradeLicenseDetail?.applicationDocuments?.filter((e) => e.documentType === "Registration Certificate") || [];
      initFormMTDocs([...regCert, ...documents]);
    } catch (error) {
      console.error("Error fetching migrated data:", error);
    }
  }

  useEffect(() => {
    fetchLTPData();
  }, []);

  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);

  const onSubmit = (data) => {
    handleTabChange(2, data);
  };
  return (
    <section className="groupContainer">
      <form onSubmit={handleSubmit(onSubmit)}>
        {formData?.edcrNumber && (
          <div className="formContainer">
            <div className="formHeaderContainer">
              <InfoBox>
                Please download the <strong>Drawing</strong>, add your <strong>Digital Signature</strong> and then upload the signed file to the
                Drawing PDF File Section <span className="mandatory">*</span>.
              </InfoBox>
            </div>
          </div>
        )}
        {formData?.edcrNumber && (
          <SummaryCard className="formContainer">
            <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
              <div style={{ width: "100%" }}>
                <table style={{ width: "100%", borderCollapse: "collapse", padding: "2rem" }}>
                  <Grid item xs={12} md={6}>
                    {" "}
                    {/* Two items per row on medium screens and above */}
                    <Grid container spacing={2} style={{ padding: "1rem" }}>
                      <Grid item xs={6}>
                        <strong>{"Drawing Pdf"} </strong>:
                      </Grid>{" "}
                      {/* Label part */}
                      <Grid item xs={6}>
                        <FaFilePdf
                          color="#a10505"
                          style={{ width: "20px", height: "30px" }}
                          onClick={() => window.open(formData?.updatedDxfFile, "_blank")}
                        />
                      </Grid>
                      {/* <Grid item xs={6}><strong>{'Plan Report'} </strong>:</Grid>
                                        <Grid item xs={6}>
                                            <FaFilePdf
                                                color="#a10505"
                                                style={{ width: '20px', height: '30px' }}
                                                onClick={() => window.open(formData?.planReport, '_blank')}
                                            />
                                        </Grid>
                                        <Grid item xs={6}><strong>{'.dxf File'} </strong>:</Grid>
                                        <Grid item xs={6}>
                                            <FaFilePdf
                                                color="#a10505"
                                                style={{ width: '20px', height: '30px' }}
                                                onClick={() => window.open(formData?.dxfFile, '_blank')}
                                            />
                                        </Grid> */}
                    </Grid>
                  </Grid>
                </table>
              </div>
            </div>
          </SummaryCard>
        )}

        {/* <div className="formContainer">
          <div className="formHeaderContainer card-stript">
            <InfoBox>Sample Affidavit</InfoBox>
          </div>
        </div> */}
        {/* <SummaryCard className="formContainer affidavit-box">
          <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
            <div style={{ width: "100%" }}>
              <table style={{ width: "100%", borderCollapse: "collapse", padding: "2rem" }}>
                <Grid item xs={12} md={6}> */}
        {" "}
        {/* Two items per row on medium screens and above */}
        {/* <Grid container spacing={2} style={{ padding: "1rem" }}> */}
        {/* <Grid item xs={6}> */}
        {/* <strong>{"Affidavit Pdf"} </strong>: */}
        {/* </Grid>{" "} */}
        {/* Label part */}
        {/* <Grid item xs={6}> */}
        {/* <FaFilePdf */}
        {/* color="#a10505" */}
        {/* style={{ width: "20px", height: "30px" }} */}
        {/* onClick={() => getDocumentByFileStoreId("9db90601-fd5e-416a-8fe9-cac1eec638d1", setIsPreviewLoading)} */}
        {/* /> */}
        {/* </Grid> */}
        {/* </Grid> */}
        {/* </Grid> */}
        {/* </table> */}
        {/* </div> */}
        {/* </div> */}
        {/* </SummaryCard> */}
        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("Mandatory Documents")}</h2>
          </div>

          <div className="formInputContainer common-app-form Upload-Input2 d-block only-white-bg">
            <div className="columnWrapper">
              <Row className="inner-mini-wrapper">
                <Col md={6}>
                  <FileUploader
                    label={t("Architect/Engineer Registration Certificate")}
                    control={control}
                    name="Architect/Engineer Registration Certificate"
                    validationMsg="Upload File"
                    required
                    isMandatory
                  />
                </Col>

                <Col md={6}>
                  <FileUploader
                    isMandatory
                    label={t("Common Affidavit")}
                    control={control}
                    name="Common Affidavit"
                    validationMsg="Upload File"
                    required
                  />
                </Col>
                <Col md={6}>
                  <FileUploader
                    isMandatory
                    label={t("Calculation sheet of Estimate with Affidavit")}
                    control={control}
                    name="Calculation sheet of Estimate with Affidavit"
                    validationMsg="Upload File"
                    required
                  />
                </Col>
                <Col md={6}>
                  <FileUploader isMandatory label={t("Drawing PDF")} control={control} name="drawingPdf" validationMsg="Upload File" required />
                </Col>

                <Col md={6}>
                  <FileUploader
                    isMandatory
                    label={t("Owner Affidavit")}
                    control={control}
                    name="ownerAffidavit"
                    validationMsg="Upload File"
                    required
                  />
                </Col>

                {!isScheme && (
                  <Col md={6}>
                    <FileUploader isMandatory label={t("Khatauni")} control={control} name="khatauni" validationMsg="Upload File" required />
                  </Col>
                )}

                {!isScheme && (
                  <Col md={6}>
                    <FileUploader
                      isMandatory
                      label={t("Mutation Letter")}
                      control={control}
                      name="Mutation Document/Possession Letter"
                      validationMsg="Upload File"
                      required
                    />
                  </Col>
                )}

                {isScheme && (
                  <Col md={6}>
                    <FileUploader
                      isMandatory
                      control={control}
                      label={t("Allotment Letter")}
                      name="allotmentLetter"
                      validationMsg="Upload File"
                      required
                    />
                  </Col>
                )}

                <Col md={6}>
                  <FileUploader
                    label={t("Registry Deed/up to date payment certificate from property section/Hire Purchase Tentant/Agreement")}
                    control={control}
                    name="registrySaleDeedHPTA"
                    isMandatory
                    validationMsg="Upload File"
                    required
                  />
                </Col>

                {isScheme && (
                  <Col md={6}>
                    <FileUploader
                      isMandatory
                      label={t("Possession Letter")}
                      control={control}
                      name="possessionLetter"
                      validationMsg="Upload File"
                      required
                    />
                  </Col>
                )}

                <Col md={6}>
                  <FileUploader isMandatory label={t("LTP Affidavit")} control={control} name="ltpAffidavit" validationMsg="Upload File" required />
                </Col>

                <Col md={6}>
                  <FileUploader
                    isMandatory
                    label={t("Structural Audit Report")}
                    control={control}
                    name="structuralAuditReport"
                    validationMsg="Upload File"
                    required
                  />
                </Col>

                {!isScheme && (
                  <Col md={6}>
                    <FileUploader
                      isMandatory
                      label={t("Developer/Consortium/Sales Agreement")}
                      control={control}
                      name="developerConsortiumSalesAgreement"
                      validationMsg="Upload File"
                      required
                    />
                  </Col>
                )}

                {!isDA && (
                  <Col md={6}>
                    <FileUploader
                      isMandatory
                      label={t("Upto date payment letter")}
                      control={control}
                      name="uptodatePaymentLetter"
                      validationMsg="Upload File"
                      required
                    />
                  </Col>
                )}

                <Col md={12}>
                  <div class="text-red important-note">Note: (pdf file only and Max file Size 30 MB)*</div>
                </Col>
              </Row>

              <Row className="inner-mini-wrapper">
                <Col md={6}>
                  <FileUploader
                    isMandatory
                    label={t("Site Photo")}
                    control={control}
                    name="sitePhoto"
                    validationMsg="Upload File"
                    required
                    maxFiles={4}
                    tab={2}
                  />
                </Col>
                <Col md={12}>
                  <div className="text-red important-note">Note: (jpg, jpeg, png file only and Max file Size 10 MB)*</div>
                </Col>
              </Row>
            </div>
          </div>
        </div>

        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("Conditional Documents")}</h2>
          </div>

          <div className="formInputContainer common-app-form Upload-Input2 d-block only-white-bg">
            <div className="columnWrapper">
              <Row className="inner-mini-wrapper">
                <Col md={6}>
                  <FileUploader label={t("Additional Document if any")} control={control} name="additionalDoc" validationMsg="Upload File" />
                </Col>
                <Col md={6}>
                  <FileUploader label={t("Structural Drawing and Design ")} control={control} name="structuraldrawing" validationMsg="Upload File" />
                </Col>
                <Col md={6}>
                  <FileUploader
                    label={t("Structural Stability Certificate")}
                    control={control}
                    name="structuralcertificate"
                    validationMsg="Upload File"
                  />
                </Col>
                <Col md={6}>
                  <FileUploader
                    label={t("Structural Design calculation Report")}
                    control={control}
                    name="calculationReport"
                    validationMsg="Upload File"
                  />
                </Col>
                <Col md={6}>
                  <FileUploader
                    control={control}
                    label={t("Vetted Structure and drawing along with certificate")}
                    name="vettedStructure"
                    validationMsg="Upload File"
                  />
                </Col>
                <Col md={6}>
                  <FileUploader
                    label={t("Annexture 7, 8, 9, 10 duly signed by Owner, Architect and Structure Engineer.")}
                    control={control}
                    name="annexture789"
                    validationMsg="Upload File"
                  />
                </Col>
                {isDA && (
                  <Col md={6}>
                    <FileUploader label={t("Upto date payment letter")} control={control} name="uptodatePaymentLetter" validationMsg="Upload File" />
                  </Col>
                )}
                <Col md={12}>
                  <div class="text-red important-note">Note: (pdf file only and Max file Size 30 MB)*</div>
                </Col>
              </Row>

              <Row className="inner-mini-wrapper">
                <Col md={6}>
                  <FileUploader
                    label={t("Approved Layout sanctioned Letter")}
                    control={control}
                    name="Approved Layout Sanctioned Letter"
                    validationMsg="Upload File"
                  />
                </Col>
                <Col md={12}>
                  <div className="text-red important-note">Note: (jpg, jpeg, png file only and Max file Size 10 MB)*</div>
                </Col>
              </Row>
            </div>
          </div>
        </div>

        <div className="footerContainer">
          <div className="buttonWrapper">
            <ButtonWrapper
              variant="contained"
              color="error"
              size="medium"
              label="Prev"
              sx={{ backgroundColor: "#CCC" }}
              onClick={() => handleTabChange(0)}
            />
            <ButtonWrapper variant="contained" color="success" size="medium" label="Save" type="submit" sx={{ backgroundColor: "#157CB3" }} />
          </div>
        </div>
      </form>
    </section>
  );
};

export default Step2;
